export const LANGUAGES = [
  { label: 'English', code: 'en' },
  { label: 'Español', code: 'es' },
  { label: 'Français', code: 'fr' },
];
